
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seja-um-profissional/cadastro",
      function () {
        return require("private-next-pages/seja-um-profissional/cadastro/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seja-um-profissional/cadastro"])
      });
    }
  